import { SwitchThumbSkeleton, SwitchSkeleton } from '../styled-components'

const SwitchSkeletonComponent = ({ size, dataState }) => {
  return (
    <SwitchSkeleton size={size} data-state={dataState}>
      <SwitchThumbSkeleton size={size} data-state={dataState} />
    </SwitchSkeleton>
  )
}

export default SwitchSkeletonComponent
